import type { User } from "types/UserZendesk";
import { IoSearchOutline } from "react-icons/io5";
import { Button } from "@components/atoms";
import { zafClient } from "@services/Zendesk";

interface SearchUsersProps {
    searchTerm: string;
    setSearchTerm: (term: string) => void;
    users: User[];
    loading: boolean;
    noUsers: string;
    searchUsers: () => void;
    selectExistingUser: (user: User) => void;
    linkUser: boolean;
}

export function SearchExistingUsers( { searchTerm, setSearchTerm, users, loading, noUsers, searchUsers, linkUser, selectExistingUser }: SearchUsersProps) {
    return (
        <div className="flex flex-col gap-2 mt-6">
            <small className="text-gray-700 text-sm font-semibold">
                Pesquise por conta existente
            </small>
            <div className="flex gap-2">
                <div className="flex items-center border rounded-md p-2 w-full border-gray-200">
                    <IoSearchOutline className="text-gray-400" />
                    <input
                        className="w-full ml-2 outline-none"
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Busque por conta já existente"
                    />
                </div>
                <Button onClick={searchUsers} disabled={!searchTerm}>
                    {loading ? 'Buscando...' : 'Buscar'}
                </Button>
            </div>
            {noUsers && <div className="text-gray-500 mt-2">{noUsers}</div>}

            {users.length > 0 && (
                <div className="border rounded-lg p-2 mt-2 border-gray-200">
                    {users.map((user) => (
                        <div
                            key={user.id}
                            className="p-2 hover:bg-gray-100 cursor-pointer border-b last:border-b-0 border-gray-200 rounded"
                            onClick={() => linkUser ? zafClient.invoke('routeTo', 'user', user.id) : selectExistingUser(user)}
                        >
                            <div className="font-medium">{user.name} - <small>id: {user.id}</small></div>
                            <div className="text-sm text-gray-500">{user.email}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}